const KEY = 'remote-ai-active-session'

export interface PersistedSession {
  session_id: string
  server_id: number
  target_server: string
}

export function saveActiveSession(s: PersistedSession): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s))
  } catch {
    // ignore quota / disabled storage
  }
}

export function loadActiveSession(): PersistedSession | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const p = JSON.parse(raw)
    if (
      typeof p?.session_id === 'string' &&
      typeof p?.server_id === 'number' &&
      typeof p?.target_server === 'string'
    ) {
      return p as PersistedSession
    }
  } catch {
    // ignore parse errors
  }
  return null
}

export function clearActiveSession(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
